import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Button} from 'views/components';
import {Translate} from 'views/module';

const Edit = (props) => {
  const {
    bioQuestions,
    EditComponent,
    changeToView,
    saveBioQuestions,

    ...restProps
  } = props;

  const [fields, setFields] = React.useState({});
  const [isSaving, setIsSaving] = React.useState(false);

  const onSave = () => {
    const onComplete = () => {
      setIsSaving(false);
      changeToView();
    };

    setIsSaving(true);
    saveBioQuestions(fields, onComplete);
  };

  return (
    <Stack spacing={3}>
      <EditComponent
        bioQuestions={bioQuestions}
        fields={fields}
        setFields={setFields}
        {...restProps}
      />
      <Stack direction="row" justifyContent="flex-end" spacing={1}>
        <Button variant="outlined" onClick={changeToView}>
          <Translate expression="generic.Cancel" />
        </Button>
        <Button
          loading={isSaving}
          variant="contained"
          onClick={onSave}
        >
          <Translate expression="generic.Save" />
        </Button>
      </Stack>
    </Stack>
  );
};

Edit.propTypes = {
  bioQuestions: PropTypes.object.isRequired,
  EditComponent: PropTypes.elementType.isRequired,
  changeToView: PropTypes.func.isRequired,
  saveBioQuestions: PropTypes.func.isRequired,
};

export default React.memo(Edit);
